(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["hero-section"] && !window.DesignMode) return;
  try {
    
      
              
      var swiper = new Swiper(".hero_swiper", {
        slidesPerView: 5,
        centeredSlides: true,
        spaceBetween: 0,
        autoplay:false,
        loop: false,  
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".hero_swiper .swiper-button-next",
          prevEl: ".hero_swiper .swiper-button-prev",
        },
        breakpoints: {
            1920: {
                slidesPerView: 5,
                spaceBetween: 0
            },
            1366: {
                slidesPerView: 5,
                spaceBetween: 20
            },
            1028: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 0
            },
            375: {
                slidesPerView: 1,
                spaceBetween: 0
            }
        }
      });

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !window.DesignMode) return;
  try {
    
  var swiper2 = new Swiper(".swiper_tabs", {
    slidesPerView: 6,
    centeredSlides: false,
    loop:false,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper_tabs .swiper-button-next",
      prevEl: ".swiper_tabs .swiper-button-prev",
    },
      breakpoints: {
          1920: {
              slidesPerView: 6,
              spaceBetween: 20
          },
          1550: {
              slidesPerView: 5,
              spaceBetween: 20
          },
           1366: {
              slidesPerView: 5,
              spaceBetween: 20
          },
          1280: {
              slidesPerView: 5,
              spaceBetween: 20
          },
          1024: {
              slidesPerView: 4,
              spaceBetween: 20
          },
          768: {
              slidesPerView: 3,
              spaceBetween: 20
          },
          480: {
              slidesPerView: 1,
              spaceBetween: 0
          },
          375: {
              slidesPerView: 1,
              spaceBetween: 0
          },
          340: {
              slidesPerView: 1,
              spaceBetween: 0
          }
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs2"] && !window.DesignMode) return;
  try {
    
  var swiper2 = new Swiper(".swiper_tabs2", {
    slidesPerView: 6,
    grid: {
      rows: 2,
    },
    centeredSlides: false,
    loop:false,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper_tabs2 .swiper-button-next",
      prevEl: ".swiper_tabs2 .swiper-button-prev",
    },
      breakpoints: {
          1920: {
              slidesPerView: 6,
              spaceBetween: 20
          },
          1550: {
              slidesPerView: 5,
              spaceBetween: 20
          },
           1366: {
              slidesPerView: 5,
              spaceBetween: 20
          },
          1280: {
              slidesPerView: 5,
              spaceBetween: 20
          },
          1024: {
              slidesPerView: 4,
              spaceBetween: 20
          },
          768: {
              slidesPerView: 3,
              spaceBetween: 20
          },
          480: {
              slidesPerView: 1,
              spaceBetween: 0
          },
          375: {
              slidesPerView: 1,
              spaceBetween: 0
          },
          340: {
              slidesPerView: 1,
              spaceBetween: 0
          }
      }
  });

  } catch(e) { console.error(e); }
})();

})();
